import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'react-toastify';

import { matchKeys } from '@/hooks/matches/matchKeys';
import { updateMatchup, UpdateMatchupData } from '@/services/actions/updateMatchup';
import { MatchupStatusApiMap, MatchupStatusEnum } from '@/domain/constants/constants';

export const useUpdateMatchup = () => {
	const queryClient = useQueryClient();

	return useMutation({
		mutationFn: (data: UpdateMatchupData) => updateMatchup(data),
		onError: (error: Error) => {
			toast.error(error.message || 'Unable to update matchup. Please try again.', {
				autoClose: 2000
			});
		},
		onSuccess: (_, { matchup_uuid, matchup_status, lineupPublishedDate }: UpdateMatchupData) => {
			queryClient.invalidateQueries({ queryKey: matchKeys.matches(matchup_uuid) });
			if (
				matchup_status === MatchupStatusApiMap[MatchupStatusEnum.SCHEDULED_WAITING_FOR_HOME_TEAM_LINEUP] ||
				matchup_status === MatchupStatusApiMap[MatchupStatusEnum.SCHEDULED_WAITING_FOR_AWAY_TEAM_LINEUP] ||
				matchup_status === MatchupStatusApiMap[MatchupStatusEnum.READY_TO_BE_STARTED_STATUS]
			) {
				toast.success('Lineup successfully completed.');
			} else if (lineupPublishedDate) {
				toast.success('Lineups published successfully');
			}
		}
	});
};
